export { TCSCommunicationOption } from './generated/TCSCommunicationOption.js';